import { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getAnimals } from '../../actions/other/animalsActions'
import { getForSelect } from '../../actions/other/lotsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import { useNavigate } from 'react-router-dom'

export default function Animals() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()
    const navigate = useNavigate()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {animals, resultanimal, loading, total} = useSelector(state=>state.animals)

    useEffect(() => {
        if(clientauth){
            dispatch(getAnimals(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getAnimals(page, limit, search))
        }
    }, [page, limit, search])

    const goToAnimalDetails = (animalId) => {
        navigate(`/${t("url.breeder.breeder")}/${t("url.breeder.animal")}/${animalId}`)
    }

    useEffect(() => {
        if(resultanimal){
            let resultanimalnow = resultanimal
            dispatch({ type: 'ANIMAL_RESET_RESULT' })
            switch (resultanimalnow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.animal.addsuccess')
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.animal.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.animal.editSuccess')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultanimal])

    const columnsAnimal = [
        {
            name: t('admin.animal.id'),
            cell: animal =>
                <div className='cursor' onClick={() => goToAnimalDetails(animal._id)}>
                    {animal.identifier || '—'}
                </div>,
            selector: (animal) => animal.identifier || '—',
            sortable: true,
        },{
            name: t('admin.animal.lot'),
            cell: animal =>
                <div className='cursor' onClick={() => goToAnimalDetails(animal._id)}>
                    {animal?.lot?.identifier || '—'}
                </div>,
            selector: (animal) => animal?.lot?.identifier || '—',
            sortable: true,
        },{
            name: t('admin.animal.category'),
            cell: animal =>
                <div className='cursor' onClick={() => goToAnimalDetails(animal._id)}>
                    {t('admin.animal.category_'+animal?.category) || '—'}
                </div>,
            selector: (animal) => t('admin.animal.category_'+animal?.category) || '—',
            sortable: true,
        },{
            name: t('admin.animal.zone'),
            cell: animal =>
                <div className='cursor' onClick={() => goToAnimalDetails(animal._id)}>
                    {animal?.lot?.zone?.name || '—'}
                </div>,
            selector: (animal) => animal?.lot?.zone?.name || '—',
            sortable: true,
        },{
            name: t('global.actions'),
            width: '100px',
            cell: animal =>
                <div className='cursor text-color2' onClick={() => goToAnimalDetails(animal._id)}>
                    {t('global.details')}
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.animal.animals')}</h1>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {animals?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsAnimal}
                                                data={animals}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.animal.thereisnotanimal')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
        </Container>
    )
}